const ADDITIONAL_INVOICE = 50440002
const ADDITIONAL_FLAG = 'A'

export function getInvoiceMonthOrReference (invoice) {
  const monthOrReference = invoice.mes ?? invoice.month ?? invoice.reference

  return invoice.tariffPeriodType === ADDITIONAL_INVOICE
    ? monthOrReference + ADDITIONAL_FLAG : monthOrReference
}
